/* 智慧畜牧平台数据 */

/* 搜索数据 */
export const resetOrSearch = [
  { title: '重置', icon: 'el-icon-refresh', class: 'btReset', event: 'resetForm' },
  { title: '搜索', icon: 'el-icon-search', class: 'btSerch', event: 'submitForm' }
];

/* 智慧畜牧 首页 */
export const homeviewNavData = [
  { title: '首页', to: { path: '/zzry/homeview' } },
  { title: '首页' }
];

// 数据统计
export const homeDataStatistics = [
  { imgUrl: '../../../static/image/farm.png', title: '养殖场/户', number: 0, pie: '个', mark: 'farmCount' },
  { imgUrl: '../../../static/image/video.png', title: '设备数量', number: 0, pie: '台', mark: 'deviceCount' },
  { imgUrl: '../../../static/image/u235.png', title: '畜只数量', number: 0, pie: '只', mark: 'totalLivestockCount' },
  { imgUrl: '../../../static/image/u234.png', title: '防疫人员', number: 0, pie: '人', mark: 'immunizerUserCount' },
  { imgUrl: '../../../static/image/u238.png', title: '疫苗接种量', number: 0, pie: '头份', mark: 'immunizerLivestockCount' },
];

// 屠宰监管数据
export const slaughterSupervision = [
  { imgUrl: '../../../static/image/c6.png', title: '屠宰场', number: 0, pie: '个', mark: 'butcherCount' },
  { imgUrl: '../../../static/image/u246.png', title: '今日进场次数', number: 0, pie: '次', mark: 'orderCount' },
  { imgUrl: '../../../static/image/c7.png', title: '今日进场畜只', number: 0, pie: '只', mark: 'livestockCount' },
];

// 技术服务数据
export const technicalService = [
  { imgUrl: '../../../static/image/u288.png', title: '技术专家', number: 0, pie: '人', mark: 'expertCount' },
  { imgUrl: '../../../static/image/u292.png', title: '直播培训', number: 0, pie: '场', mark: 'liveCount' },
  { imgUrl: '../../../static/image/u296.png', title: '课件总量', number: 0, pie: '个', mark: 'courseCount' }, 
];

// 快捷操作数据
export const quickActions = [
  { imgUrl: '../../../static/image/facility.png', title: '设备列表', path: '/zzry/padList', status: true, },
  { imgUrl: '../../../static/image/supplies.png', title: '物料信息', path: '/zzry/info', status: true, },
  { imgUrl: '../../../static/image/butcher.png', title: '屠宰监控', path: '/homeZ/slaughterCur', status: true, },
  { imgUrl: '../../../static/image/specialist.png', title: '添加专家', path: '/zzry/technicalServices', status: true, },
  { imgUrl: '../../../static/image/course.png', title: '新增课程', path: '/zzry/coursewareVideo', status: true, },
  { imgUrl: '../../../static/image/publish.png', title: '发布内容', path: '/zzry/policy', status: true, },
];

/* 经营主体 */
export const homeFarmNavData = [
  { title: '经营主体', to: { path: '/zzry/homeFarm' } },
  { title: '经营主体' }
];
  
export const homeFarmTitleData = {
  title: '经营主体',
  totalType: '',
  bntList: [
    { icon: 'el-icon-download', name: '下载模版', click: 'downLoad', type: '' },
    { icon: 'el-icon-document-add', name: '导入数据', click: 'import', type: '', function: 'import' },
    { icon: 'el-icon-upload2', name: '批量导出', click: 'export', type: '' },
    { icon: 'el-icon-plus', name: '新增主体', click: 'add', type: 'solid' },
  ],
};

/* 实时监控管理 */
// 设备列表
export const padListNavData = [
  { title: '实时监控管理', to: { path: '/zzry/padList' } },
  { title: '设备列表' }
];

export const padListTitleData = {
  title: '设备列表',
  totalType: '',
  bntList: [],
};

// AI算法统计
export const aiStatisticsNavData = [
  { title: '实时监控管理', to: { path: '/zzry/padList' } },
  { title: 'AI算法统计' }
];
  
export const aiStatisticsTitleData = {
  title: 'AI算法统计',
  totalType: '',
  bntList: [],
};

/* 疾病防治管理 */
// 物料信息
export const infoNavData = [
  { title: '疾病防治管理', to: { path: '/zzry/info' } },
  { title: '物料信息' }
];
    
export const infoTitleData = {
  title: '物料信息',
  totalType: '',
  bntList: [
    { icon: 'el-icon-shopping-bag-1', name: '待领取', click: 'unclaimed', show: false, number: 0 },
    { icon: 'el-icon-plus', name: '新增物料', click: 'add', type: 'solid', show: false },
  ],
};

// 出入库记录
export const listNavData = [
  { title: '疾病防治管理', to: { path: '/zzry/info' } },
  { title: '出入库记录' }
];
      
export const listTitleData = {
  title: '领取',
  totalType: '',
  bntList: [],
};

export const listTabsData = [
  { index: 0, title: '领取' },
  { index: 1, title: '入库' },
  { index: 2, title: '下发' },
  { index: 3, title: '出库' },
];

/* 屠宰溯源管理 */
// 实时监督
export const slaughterCurNavData = [
  { title: '屠宰溯源管理', to: { path: '/homeZ/slaughterHouseCurrent' } },
  { title: '实时监督' }
];

export const slaughterTypeList = [
  { title: '屠宰场' }
];

// 屠宰进场记录
export const slaughterListNavData = [
  { title: '屠宰溯源管理', to: { path: '/homeZ/slaughterCur' } },
  { title: '屠宰进场记录' }
];

export const slaughterListTitleData = {
  title: '屠宰进场记录',
  totalType: '',
  bntList: [],
};

/* 技术服务 */
// 专家管理
export const technicalServicesNavData = [
  { title: '技术服务', to: { path: '/zzry/technicalServices' } },
  { title: '专家管理' }
];
  
export const technicalServicesTitleData = {
  title: '专家管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

// 直播培训
export const liveTrainingNavData = [
  { title: '技术服务', to: { path: '/zzry/technicalServices' } },
  { title: '直播培训' }
];
    
export const liveTrainingTitleData = {
  title: '直播培训',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

export const liveTrainingTabsData = [
  { mark: 'live', title: '直播计划' },
  { mark: 'playback', title: '直播历史' },
];

// 课程管理
export const coursewareVideoNavData = [
  { title: '技术服务', to: { path: '/zzry/technicalServices' } },
  { title: '课程管理' }
];

export const coursewareVideoTitleData = {
  title: '课程管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

// 视频管理
export const videoEditNavData = [
  { title: '技术服务', to: { path: '/zzry/technicalServices' } },
  { title: '视频管理' }
];

export const videoEditTitleData = {
  title: '视频管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

// 草稿视频
export const serviceInformationNavData = [
  { title: '技术服务', to: { path: '/zzry/technicalServices' } },
  { title: '草稿视频' }
];

export const serviceInformationTitleData = {
  title: '草稿视频',
  totalType: '',
  bntList: [],
};

/* 内容管理 */
export const policyNavData = [
  { title: '内容管理', to: { path: '/zzry/policy' } },
  { title: '内容管理' }
];
  
export const policyTitleData = {
  title: '内容管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-folder-checked', name: '批量删除', click: 'openDel', show: false },
    { icon: 'el-icon-delete', name: '确认批量删除', click: 'sureDel', show: false },
    { icon: 'el-icon-folder-delete', name: '取消批量删除', click: 'closeDel', show: false },
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

export const policyTabsData = [
  { msgType: '产业政策', attachmentCount: 2, number: 0, type: true },
  { msgType: '市场行情', attachmentCount: 1, number: 0, type: false },
  { msgType: '草稿箱', attachmentCount: '', number: 0, type: false }
];

/* 系统设置 */
// 人员管理
export const personnelNavData = [
  { title: '系统设置', to: { path: '/zzry/personnel' } },
  { title: '人员管理' }
];

export const personnelTitleData = {
  title: '人员管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增防疫员', click: 'add', type: 'solid', show: false },
    { icon: 'el-icon-download', name: '模板下载', click: 'downLoad', type: '', show: false },
    { icon: 'el-icon-document-add', name: '导入数据', click: 'import', type: '', function: 'import', show: false },
  ],
};

// 机构管理
export const organizationalNavData = [
  { title: '系统设置', to: { path: '/zzry/organizational' } },
  { title: '机构管理' }
];

export const organizationalTitleData = {
  title: '机构管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
  ],
};

export const organizationalTabsData = [ '县/区级', '乡镇/街道级' ];

export const resetsTitleData = {
  title: '机构管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid', show: false },
    { icon: 'el-icon-download', name: '模板下载', click: 'downLoad', type: '', show: false },
    { icon: 'el-icon-document-add', name: '导入数据', click: 'import', type: '', function: 'import', show: false },
  ]
}


// WEBPACK FOOTER //
// ./src/assets/data/smartAnimalHusbandry.js